var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard11({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 388,
    height: 334,
    viewBox: "0 0 388 334",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 388,
    height: 334,
    rx: 24,
    fill: "#FFFEF4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 147.499,
    y: 123.5,
    width: 93.5133,
    height: 88,
    stroke: "#646037"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 147.499,
    y: 123.5,
    width: 24.9911,
    height: 88,
    stroke: "#646037"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 172.703,
    y: 123.5,
    width: 21.8407,
    height: 88,
    stroke: "#646037"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 218.384,
    y: 123.5,
    width: 22.6283,
    height: 88,
    stroke: "#646037"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 194.756,
    y: 123.5,
    width: 23.4159,
    height: 88,
    stroke: "#646037"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.819 145.308L160.819 145.308L160.823 145.301L172.49 124.883V165.819H148.664L160.819 145.308Z",
    stroke: "#646037"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M184.461 145.283L184.461 145.283L184.464 145.277L194.543 125.118V165.819H173.813L184.461 145.283Z",
    stroke: "#646037"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M207.295 145.296L207.295 145.296L207.298 145.289L218.172 124.992V165.819H195.893L207.295 145.296Z",
    stroke: "#646037"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M229.738 145.302L229.738 145.302L229.742 145.295L241.012 124.936V165.819H217.96L229.738 145.302Z",
    stroke: "#646037"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M159.56 188.096L159.56 188.096L159.556 188.102L147.499 210.051V166.031H172.13L159.56 188.096Z",
    stroke: "#646037"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M183.573 188.113L183.573 188.113L183.57 188.12L172.703 209.88V166.031H195.009L183.573 188.113Z",
    stroke: "#646037"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M205.626 188.113L205.626 188.113L205.622 188.12L194.755 209.88V166.031H217.062L205.626 188.113Z",
    fill: "#646037",
    stroke: "#646037"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M229.254 188.113L229.254 188.113L229.251 188.12L218.384 209.88V166.031H240.69L229.254 188.113Z",
    stroke: "#646037"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard11);
export default __webpack_public_path__ + "static/media/Card11.14df9e508f72678c537f182477164420.svg";
export { ForwardRef as ReactComponent };